import React from 'react';
export function Guarantee() {
  return <div className="flex items-start gap-3 max-w-md mx-auto mt-4" data-id="element-116">
      <span className="text-xl flex-shrink-0" data-id="element-117">🛡️</span>
      <div data-id="element-118">
        <p className="font-sans text-sm font-semibold text-brown/80" data-id="element-119">
          Garantía Total de 30 Días — Sin preguntas.
        </p>
        <p className="font-sans text-xs text-brown/60 leading-relaxed mt-1" data-id="element-120">
          Si en 30 días sentís que este protocolo no movió algo en vos, te
          devolvemos cada centavo. Sin preguntas. Sin trámites. Porque nuestra
          confianza en este proceso es tan grande como la tuya en el milagro.
        </p>
      </div>
    </div>;
}